<template>
  <div class="app-container">
    <SearchCollapse @update-height="getHeight" :formItemsLength="14">
    <div class="formBox " ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="116px"
        size="mini">
        <div class="formItemBox">

            <el-form-item label="车牌号:" prop="vhcNo">
              <el-input placeholder="" v-model="searchFrom.vhcNo"></el-input>
            </el-form-item>

            <el-form-item label="车辆类型:" prop="vhcTypeId">
              <el-select placeholder="请选择" v-model="searchFrom.vhcTypeId" filterable>
                <el-option v-for="item in vehicleT" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="车辆用途:" prop="purposeId">
              <el-select placeholder="请选择" v-model="searchFrom.purposeId" filterable>
                <el-option v-for="item in clyt" :key="item.id" :label="item.name"  :value="item.id"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="能源类型:" prop="energyType">
              <el-select placeholder="请选择" v-model="searchFrom.energyType" filterable>
                <el-option v-for="item in energyTypeOptions" :key="item.energyType" :label="item.energyTypeName"
                  :value="item.energyType"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排放标准:" prop="standardsId">
              <el-select placeholder="请选择" v-model="searchFrom.standardsId" filterable>
                <el-option v-for="item in pfbz" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="进厂状态(V2.0):" prop="reportInStatus2">
              <el-select v-model="searchFrom.reportInStatus2" placeholder="请选择">
                <el-option v-for="item in reportStatusOptions" :label="item.reportStatusName" :value="item.reportStatus"
                  :key="item.reportStatus">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出厂状态(V2.0):" prop="reportStatus2">
              <el-select v-model="searchFrom.reportStatus2" placeholder="请选择">
                <el-option v-for="item in reportStatusOptions" :label="item.reportStatusName" :value="item.reportStatus"
                  :key="item.reportStatus">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="进出类型:" prop="accessType">
              <el-select v-model="searchFrom.accessType" placeholder="请选择">
                <el-option v-for="item in accessTypeOptions" :label="item.accessTypeName" :value="item.accessType"
                  :key="item.accessType">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="所属单位:" prop="vhcCompanyName">
              <el-input  placeholder="" v-model="searchFrom.vhcCompanyName"></el-input>
            </el-form-item>
            <el-form-item label="行驶证号:" prop="drivingLicense">
              <el-input  placeholder="" v-model="searchFrom.drivingLicense"></el-input>
            </el-form-item> -->
            <el-form-item label="载重:" prop="weight">
              <el-input placeholder="" v-model="searchFrom.weight"></el-input>
            </el-form-item>
            <el-form-item label="车架号:" prop="vhcVinNo">
              <el-input placeholder="" v-model="searchFrom.vhcVinNo"></el-input>
            </el-form-item>
            <el-form-item label="发动机号:" prop="vhcEngineNo">
              <el-input placeholder="" v-model="searchFrom.vhcEngineNo"></el-input>
            </el-form-item>
            <el-form-item label="物料信息:" prop="materielName">
              <el-input placeholder="" v-model="searchFrom.materielName"></el-input>
            </el-form-item>
            <!-- <el-form-item label="随车清单:" prop="boardList">materielName
              <el-input  placeholder="" v-model="searchFrom.boardList"></el-input>
            </el-form-item> -->
            <el-form-item label="注册时间:" prop="registerDate">
              <el-date-picker v-model="searchFrom.registerDate" format="yyyy-MM-dd " value-format="yyyy-MM-dd "
                type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="创建时间:" prop="createTime">
              <el-date-picker v-model="searchFrom.createTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="出厂时间:" prop="inOutTime">
              <el-date-picker popper-class="timmHH" :default-time="tiemArr" v-model="searchFrom.inOutTime"
                format="yyyy-MM-dd HH" value-format="yyyy-MM-dd HH" type="datetimerange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="进厂时间:" prop="enterTime">
              <el-date-picker popper-class="timmHH" :default-time="tiemArr" v-model="searchFrom.enterTime"
                format="yyyy-MM-dd HH" value-format="yyyy-MM-dd HH" type="datetimerange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
        </div>

        <div class="searchBtnBox">
          <el-form-item><!--btnCode="00BP004B001"  v-if="btnFlg[0]"-->
            <el-button type="primary" btnCode="00BP009B001" v-if="btnFlg[0]" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>

          <!--<el-form-item btnCode="00BP004B002"  v-if="btnFlg[1]">&lt;!&ndash;&ndash;&gt;
            <el-button type="primary" @click="THimportFn()">台账导入</el-button>
          </el-form-item>
          <el-form-item btnCode="00BP004B002"  v-if="btnFlg[1]">
            <el-button type="primary" @click="modelDown">模板下载</el-button>
          </el-form-item>-->
          <el-form-item btnCode="00BP009B003" v-if="btnFlg[2]">
            <el-button type="primary" @click="exportFn" :disabled="isDisable">台账导出</el-button>
          </el-form-item>
          <el-form-item btnCode="00BM0D0100" v-if="btnFlg[3]">
            <el-button type="primary" @click="exportFnNew" :disabled="isDisableNew">合并导出</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    </SearchCollapse>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" @selection-change='selectGoods'
        @row-click="handleRowClick" class="tableComent" height="100%" style="width: 100%" center
        :row-class-name="tableRowClassName" border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
        <el-table-column property="inOutTime" width="80" :formatter="dateFormat" label="操作">
          <template scope="scope">
            <el-button type="text" btnCode="00BP009B002" v-if="btnFlg[1]"
              @click="printCar(scope.row)">查看</el-button><!---->
          </template>
        </el-table-column>
        <el-table-column property="reportStatus" width="120" label="进厂状态(V2.0)">
          <template scope="scope">
            {{ ["待上报", "上报中", "已上报"][scope.row.reportInStatus2] }}
          </template>
        </el-table-column>
        <el-table-column property="reportInDescribe2" min-width="170" :show-overflow-tooltip="true"
          label="进厂描述(V2.0)"></el-table-column>
        <el-table-column property="reportStatus" width="120" label="出厂状态(V2.0)">
          <template scope="scope">
            {{ ["待上报", "上报中", "已上报"][scope.row.reportStatus2] }}
          </template>
        </el-table-column>
        <el-table-column property="reportDescribe2" min-width="170" :show-overflow-tooltip="true"
          label="出厂描述(V2.0)"></el-table-column>
        <el-table-column property="vhcNo" width="100" label="车牌号"></el-table-column>

        <el-table-column property="enterTime" width="170" :show-overflow-tooltip="true" :formatter="dateFormat"
          label="进厂时间"></el-table-column>
        <el-table-column property="inOutTime" width="170" :show-overflow-tooltip="true" :formatter="dateFormat"
          label="出厂时间"></el-table-column>
        <!--
        <el-table-column property="accessType" label="进出类型" width="80"  >
          <template scope="scope">
            {{[ "进厂", "出厂"][scope.row.accessType-1]}}
          </template>
        </el-table-column>-->
        <!-- <el-table-column property="vhcTypeName" width="150" :show-overflow-tooltip="true" label="车辆类型"></el-table-column>
        <el-table-column property="purposeName" label="车辆用途" width="150" :show-overflow-tooltip="true"  >
          <template scope="scope">
            <span>{{scope.row.ext1?scope.row.ext1:scope.row.purposeName}}</span>
          </template>
        </el-table-column>
        <el-table-column property="vhcCompanyName" width="240" :show-overflow-tooltip="true" label="所属单位"></el-table-column>-->
        <el-table-column property="energyType" width="100" label="能源类型">
          <template scope="scope">
            {{ ["汽油", "柴油", "天然气", "电","乙醇" ,"氢能源"][scope.row.energyType - 1] }}
          </template>
        </el-table-column>
        <!-- <el-table-column property="isOverweight" width="80" label="是否超重">
          <template scope="scope">
            {{[ "否","是"][scope.row.isOverweight-1]}}
          </template>
        </el-table-column> -->

        <el-table-column property="accessType" width="100" label="进出标识">
          <template scope="scope">
            {{ ["进厂", "出厂"][scope.row.accessType - 1] }}
          </template>
        </el-table-column>

        <el-table-column property="weight" width="120" :show-overflow-tooltip="true" label="重量(吨)"></el-table-column>

        <el-table-column property="standardsName" width="100" :show-overflow-tooltip="true"
          label="排放标准"></el-table-column>
        <!--<el-table-column property="boardList" width="200" :show-overflow-tooltip="true" label="随车清单"></el-table-column>
        <el-table-column property="drivingLicense" width="170"  :show-overflow-tooltip="true" label="行驶证号"></el-table-column>-->
        <el-table-column property="vhcTypeName" min-width="170" :show-overflow-tooltip="true"
          label="车辆种类"></el-table-column>
        <el-table-column property="vhcVinNo" min-width="220" :show-overflow-tooltip="true"
          label="车架号"></el-table-column>
        <el-table-column property="vhcEngineNo" min-width="220" :show-overflow-tooltip="true"
          label="发动机号"></el-table-column>

        <!-- <template slot-scope="scope" >

          <div v-if="scope.row.tenantId == '002'">-->
        <el-table-column property="provider" min-width="220" :show-overflow-tooltip="true"
          label="供应商"></el-table-column>
        <el-table-column property="materielName" min-width="170" :show-overflow-tooltip="true"
          label="物料信息"></el-table-column>
        <el-table-column property="receiveUnit" min-width="220" :show-overflow-tooltip="true"
          label="收货单位"></el-table-column>
        <!--</div>-->

        <!--</template>-->

        <el-table-column property="dataSources" label="数据来源" width="100">
          <template scope="scope">
            {{ ["模板导入", "接口同步"][scope.row.dataSources - 1] }}
          </template>
        </el-table-column>
        <el-table-column prop="registerDate" width="170" :formatter="dateFormat1" label="注册日期"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateFormat" label="创建时间"></el-table-column>

      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo" :page-sizes="[25, 50, 100, 200, 1000]" :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 导入 -->
    <el-dialog title="导入" center :visible.sync="importDialog" @close="closeDialogFile" width="300px" top="20px">
      <input type="file" ref="file" accept=".xls,.csv,.xlsx" @change="getFile($event)">
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialog = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="DRsave()" size="mini">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出弹窗需要选年月（王平平改） -->
    <el-dialog title="导出" center :visible.sync="exportDialog" @close="exportDialogClose('exportForm')" width="500px"
      top="20px">
      <el-form :inline="true" :model="exportForm" ref="exportForm" :rules="rules" class="demo-form-inline"
        label-width="110px" size="mini">
        <el-form-item label="进厂年月:" prop="exportDialogDate">
          <el-date-picker v-model="exportForm.exportDialogDate" format="yyyy-MM" value-format="yyyy-MM" type="month"
            placeholder="选择月">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportDialogClose('exportForm')" size="mini">取 消</el-button>
        <el-button type="primary" @click="exportDialogsave('exportForm')" size="mini">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { modelDown, impDriverStandingBookExcel, getDriverStandingBookPage, cVTlist, cVPlist, cVElist } from '@/api/vgs-driver'
import SearchCollapse from '@/components/common/SearchCollapse.vue'
export default {
  components: {
    SearchCollapse
  },
  data () {
    return {
      tiemArr: ['00:00:00', '23:59:59'],
      h: '500px',
      weight: '0.00',
      dialogFlowTo: false,
      autoDialog: false,
      importDialog: false,
      tableList: [],
      vehicleT: [], // 车辆类型
      vRlist: [],
      clyt: [],
      pfbz: [],
      loading: 'false',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      dataSource: 0, // 数据来源
      accessTypeOptions: [
        {
          accessType: '',
          accessTypeName: '请选择'
        },
        {
          accessType: '1',
          accessTypeName: '进厂'
        }, {
          accessType: '2',
          accessTypeName: '出厂'
        }],
      reportStatusOptions: [
        {
          reportStatus: '',
          reportStatusName: '请选择'
        },
        {
          reportStatus: '0',
          reportStatusName: '待上报'
        }, {
          reportStatus: '1',
          reportStatusName: '上报中'
        }, {
          reportStatus: '2',
          reportStatusName: '已上报'
        }],
      energyTypeOptions: [
        {
          energyType: '',
          energyTypeName: '请选择'
        },
        {
          energyType: '-1',
          energyTypeName: '其他'
        },
        {
          energyType: '0',
          energyTypeName: '******'
        },
        {
          energyType: '1',
          energyTypeName: '汽油'
        },
        {
          energyType: '2',
          energyTypeName: '柴油'
        },
        {
          energyType: '3',
          energyTypeName: '天然汽'
        }, {
          energyType: '4',
          energyTypeName: '电'
        },
        {
          energyType: '5',
          energyTypeName: '乙醇'
        },
        {
          energyType: '6',
          energyTypeName: '氢能源'
        }
      ],
      unitPriceR: false,
      fatePriceR: false,
      FKList: [],
      addvRFlist: [],
      productTypes: [],
      FYList: [],
      isDisable: false,
      isDisableNew: false,
      btnFlg: [],
      btnIdArr: ['00BP009B001', '00BP009B002', '00BP009B003', '00BM0D0100'],
      exportDialog: false,
      exportForm: {
        exportDialogDate: ''
      },
      rules: {
        exportDialogDate: [
          { required: true, message: '请选择', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/driverStandingBookThree')
    this.getList(this.searchFrom)

    cVTlist({}).then(res => {
      this.vehicleT = res
      this.vehicleT.unshift({ id: '', name: '请选择' })
    })
    cVPlist({}).then(res => {
      this.clyt = res
      this.clyt.unshift({ id: '', name: '请选择' })
    })
    cVElist({}).then(res => {
      this.pfbz = res
      this.pfbz.unshift({ id: '', name: '请选择' })
    })
  },
  mounted () {
    this.getHeight()
  },
  methods: {
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = (pH - h - 168) + 'px'
      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcode) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.cargoBarcodes = ''
      }

      this.getList(this.searchFrom)
    },
    printCar (row) {
      this.$router.push({ name: 'VIprintThree', query: { id: row.id } })
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach(item => {
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      getDriverStandingBookPage(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 导出
    exportFn () {
      if (this.searchFrom.inOutTime || this.searchFrom.enterTime) {
        let from = JSON.parse(JSON.stringify(this.searchFrom))
        from.pageSize = 9999
        exportExcel(
          this.global.driverName + '/driverStandingBook/exportListZHB',
          from,
          '车辆台账信息'
        )
        this.isDisable = true
        setTimeout(() => {
          this.isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
      } else {
        this.$alert('因数据量过大，请选择进厂时间或者出厂时间', '系统提示')
      }
    },
    // 2022.10.18 新加功能需要新加导出按钮，之前导出保留（王平平改）
    exportDialogClose (formName) {
      this.exportDialog = false
      this.exportForm.exportDialogDate = ''
      this.$refs[formName].resetFields()
    },
    exportDialogsave (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.searchFrom.inOutTime || this.searchFrom.enterTime) {
          let from = JSON.parse(JSON.stringify(this.searchFrom))
          from.pageSize = 9999
          const loading = this.$loading({
            lock: true
            // text: '正在导出车辆台账信息...'
          })
          exportExcel(
            this.global.driverName + '/driverStandingBook/exportBookList', {
              ...from,
              enterTime: this.exportForm.exportDialogDate
            },
            '车辆台账信息'
          )
          setTimeout(() => {
            // this.$message({
            //   type: 'success',
            //   message: '车辆台账信息导出成功!'
            // })
            loading.close()
            this.exportDialog = false
            this.isDisableNew = false // 点击一次时隔两秒后才能再次点击
          }, 3000)
          // } else {
          //   this.$alert('因数据量过大，请选择进厂时间或者出厂时间', '系统提示')
          // }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    exportFnNew () {
      this.exportDialog = true
    },
    // 导入模板下载
    modelDown () {
      window.open('http://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/%E8%BD%A6%E8%BE%86%E5%8F%B0%E8%B4%A6%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx')
    },

    tableRowClassName ({ row, rowIndex }) {
      if (row.isUrgent == 2) {
        return 'warning-row'
      } else {
        return ''
      }
    },
    // 导入
    THimportFn () {
      this.importDialog = true
    },
    getFile: function (event) {
      this.file = event.target.files[0]
    },
    DRsave (event) {
      function extname (filename) {
        if (!filename || typeof filename != 'string') {
          return false
        };
        let a = filename.split('').reverse().join('')
        let b = a.substring(0, a.search(/\./)).split('').reverse().join('')
        return b
      }
      let name = extname(this.file.name)
      if (this.file == null) {
        this.$alert('文件为空,请选择文件进行导入', '系统提示')
      } else if (name != 'xlsx' && name != 'csv' && name != 'xls') { // xls,.csv
        this.$alert('请选择正确的文件格式', '系统提示')
      } else {
        let formData = new FormData()
        formData.append('file', this.file)
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        impDriverStandingBookExcel(formData).then(res => {
          loading.close()
          this.importDialog = false
          var that = this
          this.$message({
            showClose: true,
            message: res,
            duration: 0,
            type: 'success',
            onClose () {
              loading.close()
            }
          })
          that.getList(that.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            duration: 0,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    closeDialog () {
      if (this.$refs.addFrom !== undefined) {
        this.$refs.addFrom.resetFields()
      }
      if (this.$refs.FYform !== undefined) {
        this.$refs.FYform.resetFields()
      }
      this.autoFrom = {}
      this.autoVForm = { vehicles: [] }
      this.iSaddV = false
      this.$refs.table.clearSelection()
      this.FYform.storageFee = []
      this.FKform.storageFee = []
      this.FKform.isDeposit = []
    },
    closeDialogFile () {
      this.$refs.file.value = ''
    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        productClassify: 1,
        createTime: null,
        enterTime: null,
        inOutTime: null

      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = ''
      } else {
        str = t.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minutes + ':' + seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 时间格式化
    dateFormat1: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var str = ''
      if (cellValue == null) {
        str = ''
      } else {
        str = t.getFullYear() + '-' + month + '-' + date
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style  scoped lang='less'>
.searchBox {
  display: flex;

  .inpBox .el-date-editor {
    width: 350px !important;
  }
}

/deep/.autoBox .el-form-item__content {
  width: 150px;
}

/deep/ .gjhBox {
  width: 200px;

  /deep/ .el-form-item__label {
    width: 60px !important;
    flex-shrink: 0;
  }

  /deep/.el-form-item__content {
    flex-shrink: 0;
    width: 150px;
  }
}

.dialogInp {
  background: #dcedff;
  padding: 20px 0;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
}

.inpBox .el-date-editor {
  width: 210px !important;
}

/deep/ .ModifyF .inpBox .el-input__inner {
  width: 210px !important;
}

/deep/.el-input.is-disabled .el-input__inner {
  border: none;
  background-color: #dcedff;
  color: #606266;
}

.dialogtnBox {
  display: flex;
  justify-content: space-between;

  /deep/.el-form-item--mini.el-form-item {
    margin-bottom: 15px !important;
  }

}

.diqu {
  display: flex;

  /deep/.el-form-item__content {
    display: flex;

    .el-input__inner {
      width: 180px !important;
    }
  }
}

.jiage .el-form-item__content {
  position: relative;

  /deep/.el-input__inner {
    width: 96px !important;
  }
}

.danwei {
  position: absolute;
  right: 4px;
}

/deep/.el-radio {
  margin-right: 10px;
}

/deep/.tableInp .el-input__inner {
  height: 30px;
}

.el-dialog .el-form-item--mini.el-form-item {
  margin-bottom: 16px !important;
}

/deep/.el-table .warning-row {
  background: oldlace !important;
}

.el-tag {
  margin: 0 4px !important;
}

.auto1 {
  border-bottom: 1px solid #dddd;
  padding-bottom: 10px;
  margin-bottom: 14px;
}

// /deep/ .danweiBox .el-form-item__content{
//   position: relative;
//   .el-form-item__content{
//     width:100px!important;
//   }
//   .danwei{
//     position: absolute;
//     right: 4px;
//   }
// }
</style>
